export default __webpack_public_path__ + "7cf93b2c82fa397af5c2d7fb1bb63a2b.png";